import React, { useState } from "react";
import { Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

const SlabManager = ({ financialYears, setFinancialYears, selectedYear }) => {
  const [newSlab, setNewSlab] = useState({ min: "", max: "", rate: "" });
  const [isEditingSlab, setIsEditingSlab] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);

  const addSlab = () => {
    if (!selectedYear) return;

    const slabs = financialYears[selectedYear];
    const emptyMaxSlabs = slabs.filter((slab) => slab.max === "");
    if (emptyMaxSlabs.length > 0 && newSlab.max === "") {
      alert("Only one slab can have an empty 'max' value.");
      return;
    }

    for (let i = 0; i < slabs.length; i++) {
      if ((newSlab.min < slabs[i].max && newSlab.max > slabs[i].min) || (newSlab.min === slabs[i].min && newSlab.max === slabs[i].max)) {
        alert("Slab overlaps with existing one!");
        return;
      }
    }

    if (newSlab.max === "") {
      const previousSlab = slabs[slabs.length - 1];
      newSlab.max = previousSlab.max;
      newSlab.rate = previousSlab.rate;
    }

    setFinancialYears({
      ...financialYears,
      [selectedYear]: [...financialYears[selectedYear], newSlab],
    });
    setNewSlab({ min: "", max: "", rate: "" });
  };

  const deleteSlab = (index) => {
    const updatedSlabs = financialYears[selectedYear].filter((_, i) => i !== index);
    setFinancialYears({ ...financialYears, [selectedYear]: updatedSlabs });
  };

  const editSlab = (index) => {
    setEditingIndex(index);
    setNewSlab(financialYears[selectedYear][index]);
    setIsEditingSlab(true);
  };

  const saveEditedSlab = () => {
    if (!selectedYear || editingIndex === null) return;

    const slabs = financialYears[selectedYear];
    const emptyMaxSlabs = slabs.filter((slab) => slab.max === "");
    if (emptyMaxSlabs.length > 0 && newSlab.max === "") {
      alert("Only one slab can have an empty 'max' value.");
      return;
    }

    for (let i = 0; i < slabs.length; i++) {
      if (i !== editingIndex && (newSlab.min < slabs[i].max && newSlab.max > slabs[i].min)) {
        alert("Slab overlaps with existing one!");
        return;
      }
    }

    if (newSlab.max === "") {
      const previousSlab = slabs[slabs.length - 1];
      newSlab.max = previousSlab.max;
      newSlab.rate = previousSlab.rate;
    }

    const updatedSlabs = [...slabs];
    updatedSlabs[editingIndex] = newSlab;
    setFinancialYears({
      ...financialYears,
      [selectedYear]: updatedSlabs,
    });
    setNewSlab({ min: "", max: "", rate: "" });
    setIsEditingSlab(false);
    setEditingIndex(null);
  };

  return (
    <div>
      {selectedYear && (
        <div>
          <h2 className="mt-3 font-bold">{isEditingSlab ? "Edit Slab" : "Add Slab"}</h2>
          <TextField
            type="number"
            label="Min Income"
            variant="outlined"
            fullWidth
            value={newSlab.min}
            onChange={(e) => setNewSlab({ ...newSlab, min: Number(e.target.value) })}
          />
          <TextField
            type="number"
            label="Max Income"
            variant="outlined"
            fullWidth
            value={newSlab.max}
            onChange={(e) => setNewSlab({ ...newSlab, max: e.target.value })}
          />
          <TextField
            type="number"
            label="Tax Rate (%)"
            variant="outlined"
            fullWidth
            value={newSlab.rate}
            onChange={(e) => setNewSlab({ ...newSlab, rate: Number(e.target.value) })}
          />
          {isEditingSlab ? (
            <Button variant="contained" color="secondary" onClick={saveEditedSlab}>Save Edited Slab</Button>
          ) : (
            <Button variant="contained" color="primary" onClick={addSlab}>Add Slab</Button>
          )}
        </div>
      )}
      {selectedYear && financialYears[selectedYear]?.length > 0 && (
        <TableContainer component={Paper} className="mt-5">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Min Income</TableCell>
                <TableCell>Max Income</TableCell>
                <TableCell>Tax Rate (%)</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {financialYears[selectedYear].map((slab, index) => (
                <TableRow key={index}>
                  <TableCell>{slab.min}</TableCell>
                  <TableCell>{slab.max}</TableCell>
                  <TableCell>{slab.rate}</TableCell>
                  <TableCell>
                    <Button variant="outlined" size="small" color="error" onClick={() => deleteSlab(index)}>
                      Delete
                    </Button>
                    <Button variant="outlined" size="small" color="primary" onClick={() => editSlab(index)} style={{ marginLeft: "10px" }}>
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default SlabManager;
